export function getLocationNetworkCTAPageStyle() {
    return {
        root: {
            height: "100%",
            width: "68vw",
        },
    };
}
export function getServiceIconStyle(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textPrimary,
        },
    };
}
